// extracted by mini-css-extract-plugin
var _1 = "tjs-legend__generatedLegend";
var _2 = "tjs-legend__imageAnchor";
var _3 = "tjs-legend__legend tjs-_base__clearfix tjs-_base__list-reset";
var _4 = "tjs-legend__legend--svg";
var _5 = "tjs-legend__legend__inner";
var _6 = "tjs-legend__legend__legendBoxImg";
var _7 = "tjs-legend__legendOpenExternally";
var _8 = "tjs-legend__legendSpacer";
var _9 = "tjs-legend__legend--svg";
var _a = "tjs-legend__legendTitle";
var _b = "tjs-legend__legendTitleAbove";
var _c = "tjs-legend__legendTitleBelow";
var _d = "tjs-legend__legendTitles";
var _e = "tjs-legend__legend__inner";
var _f = "tjs-legend__legend__legendBoxImg";
var _10 = "tjs-legend__loader";
export { _1 as "generatedLegend", _2 as "imageAnchor", _3 as "legend", _4 as "legend--svg", _5 as "legendInner", _6 as "legendLegendBoxImg", _7 as "legendOpenExternally", _8 as "legendSpacer", _9 as "legendSvg", _a as "legendTitle", _b as "legendTitleAbove", _c as "legendTitleBelow", _d as "legendTitles", _e as "legend__inner", _f as "legend__legendBoxImg", _10 as "loader" }
export default { "generatedLegend": _1, "imageAnchor": _2, "legend": _3, "legend--svg": _4, "legendInner": _5, "legendLegendBoxImg": _6, "legendOpenExternally": _7, "legendSpacer": _8, "legendSvg": _9, "legendTitle": _a, "legendTitleAbove": _b, "legendTitleBelow": _c, "legendTitles": _d, "legend__inner": _e, "legend__legendBoxImg": _f, "loader": _10 }
